export const HomeView = (): JSX.Element => {
  return <></>
}
